
; (function () {
    angular.module("EMR.SelectServicePopup", []);


    var SelectServicePopupRoutes = [
        {
            "name": "SelectServicePopup",
            "templateUrl": "<div emr-common-service-popup></div>",
            "RoutingNumber": 4467,
            files: [
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/SelectServicePopup/Directives/CommonServicePopupDirective.js",
            ]
        }
    ];



    angular.module('EMR.SelectServicePopup')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectServicePopupRoutes, $stateProvider);
            }]);
})();